module.exports = __webpack_public_path__ + "static/img/RC.14a4301b.png";